var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 115,
    viewBox: "0 0 154 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b0bec5;}.b{fill:#fff;}.c{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-467 -715)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(490 718)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 54,
    cy: 54,
    r: 54
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M49.539,394.761,34.756,379.978a4.181,4.181,0,0,0-5.913,5.913l17.7,17.7a4.206,4.206,0,0,0,5.955,0L97.266,358.86a4.181,4.181,0,1,0-5.913-5.913Z",
    transform: "translate(-11.357 -325.713)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 104,
    height: 104
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 154,
    height: 115,
    transform: "translate(467 715)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.632cdb6a6c29c53ef117760643f70e3d.svg";
export { ForwardRef as ReactComponent };